<template>
  <div
    class="currency-switcher__container"
    v-if="isMultiCurrency"
  >
    <slot
      :currencies="activeCurrencies"
      :currency="currency"
      :is-active="isActive"
    >
      <input-select-currency
        class="currency-switcher"
        v-model="currency"
        :position-x="positionX"
        :position-y="positionY"
      >
        <template #selected-option="{ option }">
          <slot
            name="selected-option"
            :option="option"
          >
            {{ getSymbol(option.value) }}
          </slot>
        </template>
      </input-select-currency>
    </slot>
  </div>
</template>

<script setup>
import { defineAsyncComponent } from 'vue'
import { storeToRefs } from 'pinia'
import { useCurrencyStore } from '@/stores/CurrencyStore'

const InputSelectCurrency = defineAsyncComponent(() => import('&/atoms/InputSelectCurrency'))

defineProps({
  positionX: { type: String, default: 'right' },
  positionY: { type: String, default: 'bottom' }
})

const { activeCurrencies, isMultiCurrency, getSymbol } = useCurrencyStore()
const { currency } = storeToRefs(useCurrencyStore())

const isActive = value => value === currency.value
</script>

<style lang="scss" scoped>
.currency-switcher {
  display: flex;

  :deep(.v-select) {
    font-size: em(12px);

    .vs {
      &__dropdown-toggle {
        padding: 6px 12px;
        border: 0;
      }

      &__dropdown-menu {
        margin-top: 12px;
        min-width: 150px;
        overflow: hidden;
        border: 1px solid $vlg;
        padding: 0;
      }

      &__dropdown-option {
        padding-top: 6px;
        padding-bottom: 6px;
        display: flex;
        align-items: center;
      }

      &__selected-options {
        flex-wrap: nowrap;
        position: inherit;
        padding: 0;

        .vs__selected {
          opacity: 1 !important;
          margin: 0;
          padding: 0;
          position: relative !important;
        }
      }

      &__actions {
        display: flex;
        padding: 0 0 0 6px;
      }

      &__search {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;

        &:focus {
          border: 1px solid $mg;
        }
      }

      &__open-indicator {
        fill: $dg;
      }
    }
  }
}
</style>
